import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'

import { ParticipationRateTask } from './ParticipationRate'
import { PeerAssignmentTask } from './PeerAssignment'
import { PendingAgreementsTask } from './PendingAgreements'
import { PendingEvaluationsTask } from './PendingEvaluations'

interface Props {
  hideParticipationRate?: boolean
}

export const Tasks = ({ hideParticipationRate = false }: Props) => {
  const { breakpoint, isMobile } = useBreakpoint()
  const showCarousel = breakpoint === 'xl' || breakpoint === 'l'
  const minCardWidth = showCarousel ? 's360' : 'full'

  return (
    <Box
      gap="s16"
      overflowX="auto"
      flexWrap="noWrap"
      style={
        isMobile || showCarousel
          ? {
              flexDirection: showCarousel ? 'row' : 'column',
            }
          : {
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
            }
      }
    >
      {!hideParticipationRate && <ParticipationRateTask minWidth={minCardWidth} />}
      <PendingEvaluationsTask minWidth={minCardWidth} />
      <PendingAgreementsTask minWidth={minCardWidth} />
      <PeerAssignmentTask minWidth={minCardWidth} />
    </Box>
  )
}
